import React from 'react';

export default props => (
  <div className="row">
    <div className="col-xs-10 col-xs-offset-1 text-center">
      <h1 className="error-header">Oops, something went wrong</h1>
      <p className="error-message">
        It looks like we ran into an issue trying to pull up your information. Be sure to use the
        link we provided in your original offer email. If that isn't working, contact your Opendoor
        Experience Manager at&nbsp;
        <a href="mailto:contact@opendoor.com">contact@opendoor.com</a> and we'll help get this
        sorted out.
      </p>
    </div>
  </div>
);
